// extracted by mini-css-extract-plugin
export default {"container":"CustomFilter_container__zyKPh","active":"CustomFilter_active__xSg0u"};